/**
 * User Tiers Response Types
 * Type definitions for user tier distribution endpoint
 *
 * Endpoint: GET /product/api/v1/dashboard/user-tiers
 */

import type { ApiResponseWrapper } from './common';

/**
 * Individual tier distribution item
 */
export interface UserTierDistributionItem {
  tierCode: string;
  count: number;
  percentage: number;
}

/**
 * User tiers data containing total users and tier distribution
 */
export interface UserTiersData {
  totalUsers: number;
  distribution: UserTierDistributionItem[];
}

/**
 * API response wrapper for user tiers endpoint
 */
export type UserTiersApiResponse = ApiResponseWrapper<UserTiersData>;

/**
 * Tier badge styling configuration
 */
export interface TierBadgeStyle {
  background: string;
  color: string;
}

/**
 * Predefined tier badge styles for UI rendering
 */
export const tierBadgeStyles: Record<string, TierBadgeStyle> = {
  Diamond: {
    background:
      'linear-gradient(75.07deg, #120041 17.5%, #1E0B9C 39.6%, #364BA1 56.18%, #6831C2 77.43%, #4E0F6E 92.73%)',
    color: '#FFFFFF',
  },
  Platinum: {
    background:
      'linear-gradient(88.6deg, #0F0F0F 0%, #343537 50%, #70757B 100%)',
    color: '#FFFFFF',
  },
  Gold: {
    background:
      'linear-gradient(88.6deg, #AF7500 0%, #C38723 50%, #D7B94E 99.99%)',
    color: '#FFFFFF',
  },
  Silver: {
    background:
      'linear-gradient(88.6deg, #5E6366 0%, #4F5355 50%, #B8BCBF 100%)',
    color: '#FFFFFF',
  },
  Bronze: {
    background:
      'linear-gradient(88.6deg, #8B4513 0%, #CD853F 50%, #DEB887 100%)',
    color: '#FFFFFF',
  },
};

/**
 * Tier tooltip dot colors for chart rendering
 */
export const tierTooltipDotColors: Record<string, string> = {
  Diamond: '#364BA1',
  Platinum: '#343537',
  Gold: '#C38723',
  Silver: '#B8BCBF',
  Bronze: '#CD853F',
};

